import { render, staticRenderFns } from "./FlightSummary.vue?vue&type=template&id=2f821266&"
import script from "./FlightSummary.vue?vue&type=script&lang=js&"
export * from "./FlightSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports